import { createAction, props } from "@ngrx/store";
import { Customer } from "../../interfaces";

enum CustomersDataActions {
    LoadCustomers = '[Customers] Load Customers',
    LoadCustomersSuccess = '[Customers] Load Customers Success',
    LoadCustomersFailure = '[Customers] Load Customers Failure',
    SetCustomer = '[Customers] Set Customer',
    ResetCustomers = '[Customers] Reset Customers',
    ResetCustomer = '[Customers] Reset Customer'
};

export const LoadCustomersAction = createAction(
    CustomersDataActions.LoadCustomers,
    props<{ filterText: string }>()
);

export const SetCustomerAction = createAction(
    CustomersDataActions.SetCustomer,
    props<{ customer: Customer }>()
);

export const ResetCustomersAction = createAction(
    CustomersDataActions.ResetCustomers
);

export const ResetCustomerAction = createAction(
    CustomersDataActions.ResetCustomer
);

export const LoadCustomersSuccessAction = createAction(
    CustomersDataActions.LoadCustomersSuccess,
    props<{ customers: Customer[] }>()
);

export const LoadCustomersFailureAction = createAction(
    CustomersDataActions.LoadCustomersFailure,
    props<{ error: any }>()
);